/**
 * How often a view re-reads itself.
 *
 * Every dataset gets an interval — a tab left open on any page stays current
 * on its own, rather than only when someone leaves and comes back. The tiers
 * say how fast, not whether.
 *
 * Two things the query client already does make these numbers safe to leave
 * on: React Query does not run an interval while the tab is hidden, and
 * `refetchOnWindowFocus` (with a 30 s stale time) catches the view up the
 * moment it is looked at again. So an interval costs nothing for the tabs
 * nobody is watching, which is most of them.
 *
 * The header's "Live" tag marks a view polling faster than {@link POLL_BASE_MS}
 * — i.e. one where something is actually in flight.
 */

/** Something on screen is mid-flight: a queued message, a retrying delivery. */
export const POLL_LIVE_MS = 10_000;

/** A monitoring view whose numbers move on their own: the overview, workers. */
export const POLL_WATCH_MS = 30_000;

/** Everything else — it still changes, just not while you watch it. */
export const POLL_BASE_MS = 60_000;
